import { useQuery } from '@tanstack/react-query';
import { RequesedItemsAPI } from '../../modules/RequestedItems/api/requesteditemsAPI';
import { GoodsFilter, GoodsResponse } from '../../modules/WarehouseView/types';

const keyQuery = ['rquestedItems'] as const;

export const useFetchRequestItems = (filters?: Partial<GoodsFilter>) => {
  return useQuery<GoodsResponse, Error>({
    queryKey: [keyQuery, filters || {}],
    queryFn: ({ queryKey }) => RequesedItemsAPI.fetchMovements({ queryKey }),
    enabled: true,
  });
};

export const useFetchRequestItemById = (id?: string) => {
  return useQuery({
    queryKey: [keyQuery, id],
    queryFn: () => (id ? RequesedItemsAPI.fetchGoodPetition(id) : Promise.resolve(undefined)),
    enabled: !!id,
    staleTime: 0,
  });
};
